module.exports = "https://web-assets.ifttt.com/packs/media/components/x_white-2d1ed45f.svg";